@if (station?.stationUsage?.transports.length>0) {
  <sc-padding>
    <app-station-transport-action-bar [setProcessingStatusModel]="station.stationUsage.processingStatusModel"
      [setProcessingStatusModelValue]="station.stationUsage.processingStatusModelValue" [station]="station" [stationSet]="stationSet"
      [transport]="station?.stationUsage?.transports[0]">
    </app-station-transport-action-bar>
  </sc-padding>
}